var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type)?_c('file-sheet',_vm._g(_vm._b({attrs:{"src":_vm.fileData,"type":_vm.type,"name":_vm.name}},'file-sheet',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }